"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hourglass = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function Hourglass({ color = '#7f58af', size = 32, className, style, }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-hourglass'], className), style: { ...style }, children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-hourglass-after']), 
            // @ts-ignore
            style: { background: color, borderWidth: size, borderHeight: size } }) }));
}
exports.Hourglass = Hourglass;
//# sourceMappingURL=hourglass.js.map